import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Isotope from 'isotope-layout';
import GridItem from "../grid-item/grid-item";

class Grid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isotope: null,
            gridItems: []
        };
    }

    render() {
        if (this.props.gridItems) {
            var itemsList = this.props.gridItems.map(function (item, i) {
                return <GridItem name={item.name} type={item.type} link={item.link} key={i} />
            });
        }
        return (
            <div className="grid">
                {itemsList}
            </div>
        );
    }
    // set up isotope
    componentDidMount() {
        const node = ReactDOM.findDOMNode(this);
        if (!this.state.isotope) {
            this.setState({
                isotope: new Isotope(node)
            });
        } else {
            this.state.isotope.reloadItems();
        }
    }

    // update isotope layout
    componentDidUpdate(prevProps) {
        console.log("update", prevProps)
        if (this.state.isotope) {
            this.state.isotope.reloadItems();
            this.state.isotope.layout();
        }
    }
    componentWillMount() {
        this.onLoad();
    }
    componentDidMount() {
        if (this.state.isotope)
            this.state.isotope.reloadItems();
    }

    onLoad = () => {
        if (this.state.gridItems.length === 0) {
            this.props.onComponentMount()
        }
    };

}

export default Grid;


// WEBPACK FOOTER //
// ./src/components/portfolio/grid/grid.js